import React from "react";
import cx from "classnames";
function WithAside({ children, className }) {
    return <div className={cx("with-aside", className)}>{children}</div>;
}
export default WithAside;
export function Aside({ children, className, ...props }) {
    return (<aside className={cx("aside", className)} aria-label="Related articles" {...props}>
      {children}
    </aside>);
}
function MainContentCard({ children, className, ...props }) {
    return (<div className={cx("main-content-card", className)} {...props}>
      {children}
    </div>);
}
export function Main({ children, className, ...props }) {
    return (<div className={cx("main", className)} {...props}>
      <MainContentCard>{children}</MainContentCard>
    </div>);
}
export function MainHeader({ children, className, ...props }) {
    return (<div className={cx("main-header", className)} {...props}>
      {children}
    </div>);
}
export function MainBody({ children, className, ...props }) {
    return (<div className={cx("main-body", className)} {...props}>
      {children}
    </div>);
}
export function MainFooter({ children, className, ...props }) {
    return (<div className={cx("main-footer", className)} {...props}>
      {children}
    </div>);
}
